import '../../../tc-vue-mixins/src/form-mixins.scss.js';
import '../../../tc-vue-mixins/src/edit-mode.js';
import formField from '../../../tc-vue-mixins/src/form-field.js';
import inputValues from '../../../tc-vue-mixins/src/input-values.js';
import '../../../tc-vue-mixins/src/validatable.js';
import '../../../tc-vue-mixins/src/overlays.js';
import TcLabel from '../../tc-label/src/TcLabel.vue.js';

//

var script = {
  name: 'TcRadioButton',
  components: {
    TcLabel: TcLabel
  },
  mixins: [formField, inputValues],
  inheritAttrs: false,
  inject: {
    group: {
      from: 'group',
      default: null
    },
    inline: {
      from: 'inline',
      default: false
    }
  },
  props: {
    variant: {
      type: String,
      default: 'default'
    },
    darkmode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    wrapperType: function wrapperType() {
      return this.inline ? 'is-block' : ''
    }
  },
  methods: {
    variantClassName: function variantClassName(elem) {
      return this.variant === 'selection' || this.variant === 'default'
        ? (elem + "--" + (this.variant) + (this.toggleDarkMode()))
        : (elem + "--default")
    },
    toggleDarkMode: function toggleDarkMode() {
      return this.variant === 'selection' && this.darkmode ? '__dark' : ''
    }
  }
};

export default script;
